import * as Sentry from '@sentry/vue'
import { captureException as sharedCaptureException } from '@klausapp/shared/utils/error'

const captureException = (err) => {
  sharedCaptureException(Sentry, err)
}

export default captureException
